<template>
  <v-container grid-list-md>
  <v-form class="form-inline" @submit.prevent>
      <div class="uploadbox">
      <input type="file" name="unrulyPaxList"  ref="fileupload"
             @change="uploadFileChange($event.target.files)"
             accept=".csv,.xls,.xlsx,application/zip" class="input-file">
      <div class="uploadbox-text">
        <span class="glyphicon glyphicon-cloud-upload" aria-hidden="true"></span>
        <span>{{uploadboxText}}</span>
      </div>
    </div>
  </v-form>
  <v-data-table :headers="headers" :items="unruly" class="elevation-1" :pagination.sync="pagination"
    :rows-per-page-items="pagination.rowsPerPageItems" :total-items="pagination.totalItems">
    <template slot="items" slot-scope="props">
      <td class="text-xs-left">
        {{ props.item.firstName }}
      </td>
      <td class="text-xs-left">
        {{ props.item.lastName }}
      </td>
      <td class="text-xs-left">
        {{ props.item.birthday }}
      </td>
      <td class="text-xs-left">
        {{ props.item.phoneNumber }}
      </td>
      <td class="text-xs-left">
        {{ props.item.passportNumber }}
      </td>
      <td class="text-xs-left">
        {{ props.item.mailAddress }}
      </td>
    </template>
  </v-data-table>
 </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
  export default {
    name: 'UnrulyPax',
    data() {
      return {
        headers: [
          { text: 'First Name', value: 'firstName' },
          { text: 'Last Name', value: 'lastName' },
          { text: 'Birthday', value: 'birthday' },
          { text: 'Phone Number', value: 'phoneNumber' },
          { text: 'Passport Number', value: 'passportNumber' },
          { text: 'Mail Address', value: 'mailAddress' },
        ]
      };
    },
  computed: {
     ...mapGetters([
      'currentTenant',
      'isAdmin',
      'unruly',
      'loadingTransactions',
      'unrulyPaxListPagination'
    ]),
    pagination: {
      get: function () {
        return this.$store.getters.unrulyPaxListPagination
      },
      set: function (pagination) {
        this.$store.dispatch('setUnrulyPaxListPagination', pagination);
      },
    },
    uploadboxText() {
      // return this.currentUploadStatus === uploadStatus.Uploading ? 'Uploading...' : 'Upload'
      return 'Upload'
    },
  },
  watch : {
    'pagination.page'(newPage, oldPage){
      if(newPage!==oldPage && newPage !== '') this.getTransactions()
    }
  },
  created(){this.getTransactions()},
  methods: {
      uploadFileChange(fileList) {
        // handle file changes, allow only one file at a time
        if (!fileList.length || !fileList.length > 1) return

        this.settingsArchiveFile = fileList[0];
        console.log("settingsArchiveFile", this.settingsArchiveFile)
        // upload data to the server
        if (this.currentTenant !== '') {
        
          this.$store.dispatch('uploadUnrulyPax', this.settingsArchiveFile, this.currentTenant)
            .then(x => {
              this.uploadedFiles = [].concat(x)
              this.currentUploadStatus = uploadStatus.Success
              this.$notify({
                title: 'Upload Settings',
                text: 'Successfully updated settings from file: ' + this.settingsArchiveFile.name,
                type: 'success',
                duration: 15000
              })
            })
            .catch(err => {
              this.currentUploadStatus = uploadStatus.Failed

              this.$notify({
                title: 'Upload Settings',
                text: 'Something went wrong while uploading configuration archive: ' + err,
                type: 'error',
                duration: 15000
              })
            })
            .finally(() => {
              // this.updateEditorData()
              // this.$refs.fileupload.value = null
              // this.settingsArchiveFile = null
            })
        }
      },
       getTransactions() {
      this.$store.dispatch('getUnrulyPax', {
        page: this.unrulyPaxListPagination.page,
        pageSize: this.unrulyPaxListPagination.rowsPerPage,
        tenant: this.currentTenant
      })
    },
    },
  };
</script>

<style scoped>
.uploadbox-text {
  pointer-events: none;
}

.uploadbox {
  outline: 2px dashed grey;
  outline-offset: -4px;
  background: #E8E9F3;
  color: 333;
  padding: 7px 10px;
  position: relative;
  cursor: pointer;
  display: inline-block;
  min-width: 86px;
  min-height: 34px;
  text-align: center;
  vertical-align: middle;
  border-radius: 4px;
}

.input-file {
  opacity: 0;
  /* invisible but it's there! */
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
  cursor: pointer;
}

.uploadbox:hover {
  outline-color: #333;
  color: #333;
  background: lightblue;
  /* when mouse over to the drop zone, change color */
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/UnrulyPax.vue